import * as Sentry from "@sentry/capacitor";
import * as React from "react";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import SafeArea from "./Generic/SafeArea";

interface ErrorBoundaryState {
  eventId: string | null;
}

export class ErrorBoundary extends React.Component<{}, ErrorBoundaryState> {
  constructor(props: any) {
    super(props);

    this.state = {
      eventId: null,
    };
  }

  componentDidCatch(e: any, _errorInfo: any) {
    this.resizeRoot();

    const eventId = Sentry.captureException(e);

    this.setState({ eventId: eventId });
  }

  resizeRoot() {
    const root = document.getElementById("root");

    if (root !== null) {
      root.style.height = "100%";
    }
  }

  render() {
    if (this.state.eventId !== null) {
      let deviceData = null;
      const device = (window as any).device;
      if (device) {
        deviceData =
          device.platform + " " + device.version + ", " + device.manufacturer + " " + device.model;
      }

      return (
        <div className="ErrorBoundary">
          <span className="ErrorBoundary__title"> {translate(STRINGS.WHOOPS)} </span>
          <span className="ErrorBoundary__message"> {translate(STRINGS.AN_ERROR_HAS_OCCURED)}</span>
          <div className="OrientationCenterScreen__callAgencyContainer ErrorBoundary__sendReportContainer">
            <a
              href={
                "mailto:info@medflyt.com?subject=" +
                encodeURIComponent(
                  "MedFlyt Critical Error (" + deviceData + ") - CODE: " + this.state.eventId
                )
              }
            >
              <button className="AgencyRequestScreen__search">
                {translate(STRINGS.SEND_EMAIL)}
              </button>
            </a>
          </div>
          <span style={{ flexGrow: 1 }} />
          <SafeArea bottom={true}>
            <div className="ErrorBoundary__uniqueErrorCodeContainer">
              <span className="ErrorBoundary__uniqueErrorCodeLabel">
                {" "}
                {translate(STRINGS.UNIQUE_ERROR_CODE) + ": "}{" "}
              </span>
              <span>{this.state.eventId}</span>
            </div>
          </SafeArea>
        </div>
      );
    }

    return this.props.children;
  }
}
